class ScrollToTop {
  constructor() {
    this.buttons = document.querySelectorAll('.js-scroll-to-top-button');
  }

  init() {
    if (this.buttons.length > 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }
}

export default new ScrollToTop();
